// Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import showAuthEmbed from '../../lib/show-auth-embed';

import { stringInputSpec, stringSelectSpec } from '../../lib/editing-configs';

const CREATE_ACCOUNT_FORM_CONTAINER = 'create-account-form-container';

class TwoColCreateAccount extends Component {
  constructor(props) {
    super(props);

    this.showAuthForm = this.showAuthForm.bind(this);
    this.onAuthSuccess = this.onAuthSuccess.bind(this);
  }

  componentDidMount() {
    this.showAuthForm();
  }

  onAuthSuccess() {
    if (window && this.props.redirectUrl) {
      window.location = this.props.redirectUrl;
    }
  }

  showAuthForm() {
    showAuthEmbed({
      flow: this.props.flow,
      containerId: CREATE_ACCOUNT_FORM_CONTAINER,
      onSuccess: () => this.onAuthSuccess(),
      trk: this.props.trkParams,
    });
  }

  render() {
    const classnames = classNames(
      'row-two-col__create-account-form',
      this.props.className
    );
    return (
      <div className="row-two-col__create-account-container">
        <div className={classnames} id={CREATE_ACCOUNT_FORM_CONTAINER} />
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
TwoColCreateAccount.propTypes = {
  className: PropTypes.string,
  flow: PropTypes.string,
  redirectUrl: PropTypes.string,
  identity: PropTypes.object,
  trkParams: PropTypes.object,
  size: PropTypes.oneOf(['', 'sm', 'md', 'lg']),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
TwoColCreateAccount.defaultProps = {
  flow: 'basic',
  trkParams: {},
};

TwoColCreateAccount.getEditingConfig = () => [
  stringSelectSpec('flow', 'Flow ID', [
    { label: 'Basic', value: 'basic' },
    { label: 'Credit Score', value: 'credit-score' },
  ]),
  stringInputSpec('redirectUrl', 'Auth Success Redirect URL'),
];

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
TwoColCreateAccount.displayName = 'TwoColCreateAccount';

export default connect(({ identity }) => ({
  identity,
}))(TwoColCreateAccount);
